import { I18N } from 'aurelia-i18n';
import { IValidationRule } from '../i-validation-rule';
import { RuleValidationResult } from '../rule-validation-result';

export class ValidDateRule implements IValidationRule {
	constructor(private i18n: I18N, private date: string) { }

	validate(): RuleValidationResult {
		let result: RuleValidationResult = new RuleValidationResult();

		try {
			// parse the date parts to integers
			let parts = this.date.split('/');
			let day = parseInt(parts[1], 10);
			let month = parseInt(parts[0], 10);
			let year = parseInt(parts[2], 10);

			// check the ranges of month and year
			if (year < 1900 || year > 3000 || month === 0 || month > 12) {
				result.isValid = false;
			} else {
				let monthLength: number[] = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

				// adjust for leap years
				if (year % 400 === 0 || (year % 100 !== 0 && year % 4 === 0)) {
					monthLength[1] = 29;

				}

				// check the range of the day
				result.isValid = (day > 0 && day <= monthLength[month - 1]);
			}
		}
		catch (err) {
			result.isValid = false;
		}

		if (!result.isValid) {
			result.errorMessage = this.i18n.i18next.t('invalidDate', 'Date must be a valid date.');
		}

		return result;
	}
}
